export const PROXY_SCHEME = 'https';
export const PROXY_DOMAIN = 'api.jmcquade.com/igproxy';
export const DEFAULT_TYPE = 'hashTag';
export const DEFAULT_VALUE = 'catsofig';
export const DEFAULT_PAGING_1='cats';
export const DEFAULT_PAGING_2='catlovers';
export const DEFAULT_PAGING_3='cutecats';
export const DEFAULT_PAGING_4='catsofig';
export const DEFAULT_PAGING_5='catsofinstagram';
export const DEFAULT_PAGING_6='cutecats';